import styled from 'styled-components';
import color from 'tinycolor2';

export const PlaceholderAvatar = styled.div`
  width: 34px;
  height: 34px;
  background: ${(props) => color.mix(props.theme['color.text.light'], props.theme['color.surface'], 90).toString()};
  border-radius: 50%;
  border: 2px solid ${(props) => props.theme['color.surface']};
  margin-right: -10px;
  float: right;
`;
